import { Grid, Typography } from "../../basics";
import { IHeaderProps } from "./types";
import { StyledHeader } from "./styled";

const Header = (props: IHeaderProps) => {
    return (
        <StyledHeader>
            <Grid container justifyContent="space-between">
                <Grid item>
                    <Typography
                        variant="h3"
                        sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                        {props.title}
                    </Typography>
                </Grid>
                <Grid item>{props.children}</Grid>
            </Grid>
        </StyledHeader>
    );
};

export { Header };